import GameInfo from "./gameInfoCard.molecule";

export default GameInfo;
